export enum ErrorTypes {
    ARCHIVE_FAILED = 'ARCHIVE_FAILED',
    ASSIGN_TENANT_FAILED = 'ASSIGN_TENANT_FAILED',
    SEND_MESSAGE_FAILED = 'SEND_MESSAGE_FAILED',
}

class ObjectError extends Error {
    public keys?: string[];
    public type?: ErrorTypes;

    constructor(messageObj) {
        super(messageObj.key || 'An error occurred');
        this.type = messageObj.type;
        this.keys = messageObj.keys;

        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, ObjectError);
        }
    }
}

export default ObjectError;
